import React from 'react';
import PropTypes from 'prop-types';

export default function WeatherIcon({ size, color, ...rest }) {
  return (
    <svg {...rest} fill={color} width={size} height={size} viewBox="0 0 26 26">
      <path
        id="info-a"
        d="M13,-1.59872116e-14 C20.1765959,0.00749253713 25.9925075,5.82340405 26,13 C26,20.1797017 20.1797017,26 13,26 C5.82029825,26 6.39488462e-14,20.1797017 6.39488462e-14,13 C6.39488462e-14,5.82029825 5.82029825,-1.59872116e-14 13,-1.59872116e-14 Z M17.4546806,2.24544972 C13.104871,0.443699614 8.09802367,1.43962348 4.76882357,4.76882357 C1.43962348,8.09802367 0.443699614,13.104871 2.24544972,17.4546806 C4.04719983,21.8044901 8.29180007,24.6406413 13,24.6406413 C19.4258433,24.6331505 24.6331505,19.4258433 24.6406413,13 C24.6406413,8.29180007 21.8044901,4.04719983 17.4546806,2.24544972 Z M13.7246471,10.2545404 L13.7246471,17.235142 L15.0571628,17.235142 L15.0571628,18.7093064 L10.7072151,18.7093064 L10.7072151,17.235142 L12.0397307,17.235142 L12.0397307,11.7287047 L10.7072151,11.7287047 L10.7072151,10.2545404 L13.7246471,10.2545404 Z M12.82162,6.38485901 C13.0916707,6.38044919 13.3519763,6.48410846 13.5429405,6.67210427 C13.7413414,6.85597021 13.851372,7.11392415 13.8457849,7.38208782 C13.8500016,7.64999243 13.7401938,7.90742396 13.5429405,8.09207138 C13.3536332,8.2831294 13.092723,8.3889898 12.82162,8.38473636 C12.5456334,8.39195606 12.2794849,8.28362448 12.0892871,8.08665166 C11.7010326,7.69677828 11.7010326,7.07281709 12.0892871,6.68294371 C12.2790803,6.48539143 12.545504,6.37694783 12.82162,6.38485901 Z"
      />
    </svg>
  );
}

WeatherIcon.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
};

WeatherIcon.defaultProps = {
  size: 15,
  color: '#000',
};
